var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 966 966",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M906,178.55H60c-33.1,0-60,26.9-60,60v488.9c0,33.1,26.9,60,60,60h846c33.1,0,60-26.9,60-60v-488.9 C966,205.45,939.1,178.55,906,178.55z M520.5,647.55c0,16.6-13.4,30-30,30H144c-16.6,0-30-13.4-30-30v-121.5c0-16.6,13.4-30,30-30 h346.5c16.6,0,30,13.4,30,30V647.55z M822,406.85H144c-16.6,0-30-13.4-30-30s13.4-30,30-30h678c16.6,0,30,13.4,30,30 S838.6,406.85,822,406.85z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.dd93d68b6b60d3edf3497151463f5f21.svg";
export { ForwardRef as ReactComponent };